import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Avatar,
    Box,
    Chip,
    CircularProgress,
    Container,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Paper,
    Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

import { fetchMyCallRequests } from '../actions/customerActions';

const STATE_LABELS = {
    NEW: { label: 'Nueva', color: 'default' },
    IN_QUEUE: { label: 'En espera', color: 'info' },
    CALLED: { label: 'En llamada', color: 'success' },
    FINISHED: { label: 'Finalizada', color: 'default' },
    CANCELLED: { label: 'Cancelada', color: 'error' },
};

const formatDate = (value) =>
    value
        ? new Date(value).toLocaleDateString('es-AR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
          })
        : '';

const MyCallRequests = ({
    callRequests,
    isFetching,
    fetchMyCallRequests,
}) => {
    const navigate = useNavigate();

    useEffect(() => {
        fetchMyCallRequests();
    }, [fetchMyCallRequests]);

    return (
        <Container maxWidth="sm" sx={{ py: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <IconButton onClick={() => navigate('/account')}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" component="h1">
                    Mis videollamadas
                </Typography>
            </Box>

            <Paper elevation={3}>
                {isFetching ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            py: 6,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : callRequests.length === 0 ? (
                    <Typography
                        align="center"
                        color="text.secondary"
                        sx={{ py: 6, px: 2 }}
                    >
                        Todavía no hiciste ninguna videollamada.
                    </Typography>
                ) : (
                    <List>
                        {callRequests.map((callRequest) => {
                            const state =
                                STATE_LABELS[callRequest.state] || {
                                    label: callRequest.state,
                                    color: 'default',
                                };

                            return (
                                <ListItem
                                    key={callRequest.callRequestId}
                                    divider
                                >
                                    <ListItemAvatar>
                                        <Avatar
                                            src={
                                                callRequest.storeImageUrl ||
                                                undefined
                                            }
                                        >
                                            {callRequest.storeName
                                                ? callRequest.storeName[0]
                                                : '?'}
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={callRequest.storeName}
                                        secondary={[
                                            formatDate(callRequest.createdOn),
                                            callRequest.purchaseOrdersCount > 0
                                                ? `${callRequest.purchaseOrdersCount} orden(es)`
                                                : null,
                                        ]
                                            .filter(Boolean)
                                            .join(' · ')}
                                    />
                                    <Chip
                                        label={state.label}
                                        color={state.color}
                                        size="small"
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                )}
            </Paper>
        </Container>
    );
};

const mapStateToProps = (state) => {
    return {
        callRequests: state.customer.callRequests,
        isFetching: state.customer.isFetchingCallRequests,
    };
};

export default connect(mapStateToProps, { fetchMyCallRequests })(
    MyCallRequests
);
